import { render, staticRenderFns } from "./WaBtn.vue?vue&type=template&id=16ca58fc&scoped=true"
var script = {}
import style0 from "./WaBtn.vue?vue&type=style&index=0&id=16ca58fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ca58fc",
  null
  
)

export default component.exports